import format from 'date-fns/format';
import moment from 'moment';
import React, { useState } from 'react'
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { DATE_ddMMYYYY, DD_MM_yyyy } from '../../utils/constant';
import ReadAxiosc from '../axiosComponent/commonRead';
import AgGridTable from '../common/agGridTable'
import SearchRouteDropdown from "../../components/createShipmentComponent/searchRouteDropdown";
import { Headings, table_headers } from '../../utils/constants/reportingOrderDetails.constants';
import cogoToast from 'cogo-toast';
import MyConsignee from '../createShipmentComponent/searchConsigneeDropDown';
import MyConsignor from '../createShipmentComponent/searchConsignorDropDown';

function SobReport() {
  let rowData = []
  let a = new Date()
  const [start, setStart] = useState(a.setDate(a.getDate() - 15))
  const [end, setEnd] = useState(new Date())
  const [isLoading, setisLoading] = useState(false)
  const [data, setdata] = useState([])
  const [route, setRoute] = useState("");
  const [consignorCode, setConsignorCode]= useState("")
  const [consigneeCode, setConsigneeCode]= useState("")
  const endDateHandle = (e) => {
    setEnd(e)
  }
  const handleSubmit = () => {
      ReadAxiosc({
        completeURL: `${process.env.REACT_APP_TA_API_URL}/logs/sob/reports?start_date=${format(start, 'yyyy-MM-dd')}&end_date=${format(end, 'yyyy-MM-dd')}&route_id=${route}&consignee_code=${consigneeCode}&consignor_code=${consignorCode}`,
      }).then((response) => {
        if (response.data.data && response.data.status == 1) {
          setdata(response.data.data)
        } else {
          cogoToast.error(response.data.message)
          setdata([])
        }
      })}
  const startDateHandle = (e) => {
    setStart(e)
  }

  data && data.forEach((obj, index) => {
    let temp = {}
    temp.agreed_sob = obj?.agreed_sob ? obj?.agreed_sob : 0
    temp.per_day_actual_sob = obj?.per_day_actual_sob ? obj.per_day_actual_sob.toFixed(2) : 0
    temp.achieved_sob = obj?.achieved_sob ? obj.achieved_sob : 0
    temp.vendor_name = obj?.is_market_vendor === 1 ?  Headings.MARKET_VEHICLE : obj?.vendor_name ? obj.vendor_name : ''
    temp.truck_type = obj?.vehicle_type?.vehicleType ? obj.vehicle_type.vehicleType : 'NA'
    temp.consignor_city = obj?.consignor_city
    temp.consignee_city = obj?.consignee_city
    rowData[index] = temp
  })

  let columnDefs = [
    { headerName: table_headers.tms_indented_transporter || ' TMS Indented Transporter', field: 'vendor_name', tooltipField: 'vendor_name', enableRowGroup: true, enablePivot: true, filter: true },
    { headerName: table_headers.truck_type || ' Truck Type', field: 'truck_type', tooltipField: 'truck_type', enableRowGroup: true, enablePivot: true, filter: true },
    { headerName: table_headers.consignor || ' Consignor', field: 'consignor_city', tooltipField: 'consignor_city', enableRowGroup: true, enablePivot: true, filter: true },
    { headerName: table_headers.consignee || ' Consignee', field: 'consignee_city', tooltipField: 'consignee_city', enableRowGroup: true, enablePivot: true, filter: true },
    { headerName: table_headers.agreed_sob || ' Agreed SOB %', field: 'agreed_sob', tooltipField: 'agreed_sob', enableRowGroup: true, enablePivot: true, filter: true },
    { headerName: table_headers.tms_indented_sob || ' TMS Indented SOB %', field: 'per_day_actual_sob', tooltipField: 'per_day_actual_sob', enableRowGroup: true, enablePivot: true, filter: true },
    { headerName: table_headers.actual_sob || ' Actual Achieved SOB%', field: 'achieved_sob', tooltipField: 'achieved_sob', enableRowGroup: true, enablePivot: true, filter: true },
  ]
  return (
    <>
      <AgGridTable
        masters={false}
        loading={isLoading}
        columnDefs={columnDefs}
        rowData={rowData}
        pagination={false}
        hideTitleBarTools={true}
        titleBarTitle="SOB Report"
        paginationPageSize={10}
        reportsFilter={
          <>
            <div className="container-fluid  text-center p-2 w3-white">
              <div className="row">
                <div className="col-md-1 mt-1 text-left">
                  <label className='ml-2'>{Headings.DATE||"Date"}</label>
                </div>
                <div className="col-md-4">
                  <div className="d-flex" style={{ flex: 1 }}>
                    <div>
                      <DatePicker
                        selected={start}
                        onChange={startDateHandle}
                        dateFormat={DATE_ddMMYYYY}
                        selectsStart
                        startDate={a.setDate(a.getDate() - 30)}
                        showMonthDropdown
                        placeholderText="Start Date"
                        className="form-control"
                      />
                    </div>
                    &nbsp;~&nbsp;
                    <div>
                      <DatePicker
                        selected={end}
                        onChange={endDateHandle}
                        endDate={a}
                        showMonthDropdown
                        selectsEnd
                        dateFormat={DATE_ddMMYYYY}
                        placeholderText="End Date"
                        className="form-control"

                      />
                    </div>
                   
                  </div>
                
                </div>
                <div className="col-md-1 mt-1 text-left">
                <label>{Headings.ROUTE}</label>
                </div>
                <div className="col-md-4">
                <div>                   
                    <SearchRouteDropdown
                      handleChange={(event, data) =>
                        setRoute(+data.value)
                      } />
                  </div>
                </div>
                <div className="col-md-2">
                  <button type="button" onClick={handleSubmit} disabled={start && end && (route||consigneeCode||consignorCode) ? false : true} className="w3-button w3-small w3-blue w3-hover-blue w3-round">Apply</button>
                </div>
              </div>
              <div className="row mt-1">
              <div className="col-md-1 mt-1 text-left">
                <label className='ml-2'>{Headings.CONSIGNOR}</label>
                </div>
                <div className="col-md-4">                 
                    <MyConsignor
                      handleChange={(event, data) =>
                        setConsignorCode(data.value)
                      } 
                      codeValue={true}
                      nameText={true}
                      preventInitialLoading={true}
                      />
                  </div>

                  <div className="col-md-1 mt-1 text-left">
                <label>{Headings.CONSIGNEE}</label>
                </div>
                <div className="col-md-4">             
                    <MyConsignee
                      handleChange={(event, data) =>
                        setConsigneeCode(data.value)
                      } 
                      codeValue={true}
                      nameText={true}
                      preventInitialLoading={true}
                      />
                  </div>
              </div>
            </div>
          </>}
      />
    </>
  )
}

export default SobReport
